<template>
  <error-content code="401" :desc="langMap.noPermissionPage[lang]" :src="src"/>
</template>

<script>
import error401 from '@/assets/images/error-page/error-401.svg'
import errorContent from './error-content.vue'
import langMap from '@/utils/language';
import { mapState } from 'vuex';
export default {
  name: 'error_401',
  components: {
    errorContent
  },
  data () {
    return {
      langMap:langMap,
      src: error401
    }
  },
  computed: {
    ...mapState({
      lang: state => state.app.language,
    }),
  },
}
</script>
